import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FiCalendar, FiLogIn, FiLogOut, FiMapPin } from "react-icons/fi";
import { formatTimeAMPM } from "../../../Utils/timeUtils";
import { formatDateDDMMYYYY } from "../../../Utils";
import * as route from "../../../routes";

const STATUS_BADGE = {
  CHECKED_OUT: { label: "Checked Out", className: "bg-purple-100 text-purple-700" },
  CHECKED_IN: { label: "Checked In", className: "bg-green-100 text-green-700" },
  PENDING: { label: "Pending", className: "bg-red-100 text-red-700" },
};

const getInitials = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("") || "?";

// Compact card for the Checked In / Checked Out / Pending lists on mobile
const MobileKpiUserCard = ({ data }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { attendance_id, user_name, date, site_name, checkin_time, checkout_time, status } = data;
  const badge = STATUS_BADGE[status] || STATUS_BADGE.PENDING;

  // Pending users have no attendance record to open
  const openDetails = () =>
    navigate(route.VIEW_DETAILED_PAGE.replace(":id", attendance_id), {
      state: { ...location.state, from: location.pathname },
    });

  return (
    <div
      onClick={attendance_id ? openDetails : undefined}
      className={`flex items-start gap-3 p-3 mb-2 bg-white border rounded-lg shadow-sm ${
        attendance_id ? "cursor-pointer" : ""
      }`}
    >
      <div className="flex items-center justify-center w-10 h-10 shrink-0 rounded-full bg-primary/10 text-primary font-semibold text-sm">
        {getInitials(user_name)}
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2">
          <span className="font-semibold text-gray-800 truncate">
            {user_name}
          </span>
          <span
            className={`shrink-0 text-xs font-medium px-2 py-0.5 rounded-full ${badge.className}`}
          >
            {badge.label}
          </span>
        </div>

        <div className="flex items-center gap-1 mt-0.5 text-xs text-gray-500">
          <FiMapPin className="shrink-0" />
          <span className="truncate">{site_name || "Non-Site"}</span>
          <FiCalendar className="shrink-0 ml-2" />
          <span className="shrink-0">{formatDateDDMMYYYY(date) || date}</span>
        </div>

        {status === "PENDING" ? (
          <div className="mt-2 text-xs text-red-600">Not checked in yet</div>
        ) : (
          <div className="flex items-center gap-4 mt-2 text-xs">
            <span className="flex items-center gap-1 text-green-700">
              <FiLogIn />
              {checkin_time ? formatTimeAMPM(checkin_time) : "-"}
            </span>
            <span className="flex items-center gap-1 text-purple-700">
              <FiLogOut />
              {checkout_time ? formatTimeAMPM(checkout_time) : "Not yet"}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileKpiUserCard;
